module.exports = __webpack_public_path__ + "img/blog-4.43908f70.webp";